import { jobCardNativeModule } from "./JobCardNativeModule";

export function dislikeJob(
  jobKey: string,
  pageId: string,
  undo: boolean,
  tk: string | null = null,
): Promise<void> {
  const nativeModule = jobCardNativeModule();
  if (!nativeModule?.dislikeJob) {
    return Promise.reject("dislikeJob is not available");
  }
  return nativeModule.dislikeJob(jobKey, pageId, undo, tk);
}
